const prefix = 'instances-page';

export const i18n = {
    displayName: {
        id: `${prefix}.displayName`,
        defaultMessage: 'Display Name',
    },
    accountName: {
        id: `${prefix}.accountName`,
        defaultMessage: 'Account Name',
    },
    legalName: {
        id: `${prefix}.legalName`,
        defaultMessage: 'Legal Name',
    },
    salesforceId: {
        id: `${prefix}.salesforceId`,
        defaultMessage: 'Salesforce ID',
    },
    capacityGroupName: {
        id: `${prefix}.capacityGroupName`,
        defaultMessage: 'Capacity Group Name',
    },
    capacityGroupId: {
        id: `${prefix}.capacityGroupId`,
        defaultMessage: 'Capacity Group ID',
    },
    status: {
        id: `${prefix}.status`,
        defaultMessage: 'Status',
    },
    active: {
        id: `${prefix}.active`,
        defaultMessage: 'Active',
    },
    inactive: {
        id: `${prefix}.inactive`,
        defaultMessage: 'Inactive',
    },
    archived: {
        id: `${prefix}.archived`,
        defaultMessage: 'Archived',
    },
    noInstancesTitle: {
        id: `${prefix}.noInstancesTitle`,
        defaultMessage: 'No instances',
    },
    noInstancesMessage: {
        id: `${prefix}.noInstancesMessage`,
        defaultMessage: 'There are no instances to display.',
    },
    loadErrorTitle: {
        id: `${prefix}.loadErrorTitle`,
        defaultMessage: 'Could not load instances',
    },
    loadErrorMessage: {
        id: `${prefix}.loadErrorMessage`,
        defaultMessage: 'Refresh the page to try again.',
    },
} as const;
